import { PublicShell } from "@/components/brivio/public/PublicShell";
import { HomeHero } from "@/components/brivio/home/HomeHero";
import { HomeHowItWorks } from "@/components/brivio/home/HomeHowItWorks";
import { HomeProductPreview } from "@/components/brivio/home/HomeProductPreview";
import { HomeForPros } from "@/components/brivio/home/HomeForPros";
import { HomeWhyBrivio } from "@/components/brivio/home/HomeWhyBrivio";
import { PopularServices } from "@/components/brivio/PopularServices";
import { WebsiteAssistant } from "@/components/brivio/WebsiteAssistant";
import { usePageMeta } from "@/lib/usePageMeta";

export default function LandingPage() {
  usePageMeta({
    title: "Brivio | Local help. Made simple.",
    description: "Need something done? Tell Brivio. We'll find local pros for you. Free. Always. No lead fees, no commissions, no required subscription.",
    canonicalPath: "/",
  });
  return (
    <PublicShell testid="landing-page">
      <HomeHero />
      <HomeHowItWorks />
      <PopularServices />
      <HomeProductPreview />
      <HomeForPros />
      <HomeWhyBrivio />
      <WebsiteAssistant />
    </PublicShell>
  );
}
